"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const defaultValues = {
    pluginConfigs: [],
    pluginComponents: []
};
exports.PluginContext = React.createContext(defaultValues);
class Plugin extends React.Component {
    render() {
        const { id, serviceContainer, categoryContainer, drawers, widgets } = this.props;
        const pluginConfig = {
            id,
            serviceContainer,
            categoryContainer,
            drawers,
            widgets
        };
        return (React.createElement(exports.PluginContext.Consumer, null, ({ pluginConfigs, pluginComponents, DevPluginComponent, devPluginConfig }) => {
            const [Component, ...restComponents] = pluginComponents;
            // If we're in development mode
            if (DevPluginComponent) {
                if (pluginConfigs.length === 0) {
                    return (React.createElement(exports.PluginContext.Provider, { value: {
                            DevPluginComponent,
                            pluginConfigs: [...pluginConfigs, pluginConfig],
                            pluginComponents
                        } },
                        React.createElement(DevPluginComponent, null)));
                }
                else {
                    return (React.createElement(exports.PluginContext.Provider, { value: {
                            pluginConfigs,
                            pluginComponents: restComponents,
                            devPluginConfig: pluginConfig
                        } },
                        React.createElement(Component, null)));
                }
            }
            return (React.createElement(exports.PluginContext.Provider, { value: {
                    pluginConfigs: [...pluginConfigs, pluginConfig],
                    pluginComponents: restComponents,
                    devPluginConfig
                } },
                React.createElement(Component, null)));
        }));
    }
}
exports.Plugin = Plugin;
